import { MedicalExaminationType } from '../../../../graphql/graphql';

export const MEDICAL_EXAMINATION_TRANSLATION_MAP: Record<
	MedicalExaminationType,
	string
> = {
	[MedicalExaminationType.Initial]:
		'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.type.initial',
	[MedicalExaminationType.Preventive]:
		'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.type.preventive',
	[MedicalExaminationType.Emergency]:
		'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.type.emergency',
	[MedicalExaminationType.DentalTreatmentRestoration]:
		'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.type.dentalTreatmentRestoration',
};
